(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hl-product-rating"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hl-product-rating')) {
    customElements.define('hl-product-rating', class extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('a');
        this.refresh = () => {
          const carousel = document.querySelector('hl-review-carousel');
          this.target = carousel?.closest('.shopify-section') || carousel;
          this.hidden = !this.target;
          if (this.target?.id) this.link.href = '#' + this.target.id;
        };
        this.activate = event => {
          this.refresh();
          if (!this.target) return;
          event.preventDefault();
          this.target.setAttribute('tabindex', '-1');
          this.target.focus({preventScroll:true});
          this.target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
        };
        this.link.addEventListener('click', this.activate);
        document.addEventListener('DOMContentLoaded', this.refresh);
        document.addEventListener('shopify:section:load', this.refresh);
        document.addEventListener('shopify:section:unload', this.refresh);
        if (document.readyState !== 'loading') this.refresh();
      }
      disconnectedCallback() {
        this.link.removeEventListener('click', this.activate);
        document.removeEventListener('DOMContentLoaded', this.refresh);
        document.removeEventListener('shopify:section:load', this.refresh);
        document.removeEventListener('shopify:section:unload', this.refresh);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["hl-size-guide"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('hl-size-guide')) {
    customElements.define('hl-size-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const tabs = [...this.querySelectorAll('[data-guide-tab]')];
        const selectTab = (tab) => {
          tabs.forEach(item => {
            const selected = item === tab;
            item.setAttribute('aria-selected', String(selected));
            item.tabIndex = selected ? 0 : -1;
          });
          this.querySelectorAll('[data-guide-panel]').forEach(panel => {
            panel.hidden = panel.dataset.guidePanel !== tab.dataset.guideTab;
          });
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => selectTab(tab));
          tab.addEventListener('keydown', event => {
            let target;
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') target = tabs[(index + 1) % tabs.length];
            if (event.key === 'Home') target = tabs[0];
            if (event.key === 'End') target = tabs[tabs.length - 1];
            if (target) { event.preventDefault(); selectTab(target); target.focus(); }
          });
        });
        this.querySelectorAll('[data-guide-unit]').forEach(button => {
          button.addEventListener('click', () => {
            const unit = button.dataset.guideUnit;
            this.querySelectorAll('[data-guide-unit]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            this.querySelectorAll('[data-guide-value]').forEach(item => { item.hidden = item.dataset.guideValue !== unit; });
            this.querySelector('[data-guide-current-unit]').textContent = '(' + unit + ')';
          });
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
